<template>
  <div v-if="visible" class="cookie-banner">
    <div class="cookie-banner__inner">
      <p class="cookie-banner__text">
        Мы используем cookies, чтобы сайт работал корректно и удобнее подстраивался под вас.
      </p>
      <button type="button" class="cookie-banner__btn" @click="accept">
        Согласен
      </button>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'

const STORAGE_KEY = 'prestige_inside_cookie_consent'

export default {
  name: 'CookieBanner',
  setup() {
    const visible = ref(false)

    onMounted(() => {
      try {
        const stored = localStorage.getItem(STORAGE_KEY)
        visible.value = stored !== 'accepted'
      } catch {
        visible.value = true
      }
    })

    function accept() {
      try {
        localStorage.setItem(STORAGE_KEY, 'accepted')
      } catch {
        // ignore
      }
      visible.value = false
    }

    return { visible, accept }
  }
}
</script>

<style scoped lang="scss">
@import "../styles/_variables.scss";

.cookie-banner {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 120;
  padding: 12px $gap 16px;
  pointer-events: none;

  &__inner {
    pointer-events: auto;
    max-width: $container-max;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 12px 16px;
    background: rgba(0, 0, 0, 0.9);
    color: $color-primary-inverse;
    border-radius: 999px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);

    @media (max-width: $breakpoint-mobile) {
      align-items: flex-start;
      flex-direction: column;
      border-radius: 16px;
    }
  }

  &__text {
    margin: 0;
    font-size: 13px;
    line-height: 1.5;
    opacity: 0.9;
  }

  &__btn {
    flex-shrink: 0;
    padding: 8px 18px;
    font-size: 13px;
    font-weight: 600;
    border-radius: 999px;
    border: none;
    cursor: pointer;
    background: $color-accent-teal;
    color: $color-primary-inverse;
    transition: background 0.2s ease, transform 0.15s ease;

    &:hover {
      background: darken($color-accent-teal, 6%);
      transform: translateY(-1px);
    }
  }
}
</style>

